import LocalStrings from '../../assets/languages';

export const USER_ROLE_ACCESS_FEATURES = {
  tabs: {
    speaker: '',
    exhibitor: '',
    sponsor: '',
    message: '',
    maps: '',
    news: '',
    about: '', // event guide
    webview: '',
    survey: '',
    attendee: '',
    gamification: '',
    meeting: '',
    schedule: 'sessionpollandliveqa',
    social: 'moderate_social',
    gallery: 'moderate_gallery,add_gallery',
    community:
      'moderate_community,createmeetups_community,createjobpost_community',
    admin:
      'manageattendees_adminfeature,sessioncheckins_adminfeature,kioskmode_adminfeature',
    scanning: 'lead_qualification'
  },
  hasSub: ['schedule', 'social', 'gallery', 'community', 'admin', 'scanning']
};

export const ALLOWED_THUMB_TYPES = {
  xs: 30,
  sm: 30,
  md: 70,
  lg: 70
};

export const ALLOWED_FEATURE_KEYS = {
  overview: 'overview',
  schedule: 'schedule',
  exhibitor: 'exhibitor',
  sponsor: 'sponsor',
  speaker: 'speaker',
  profile: {
    personal: 'profile_personal',
    exhibitor: 'profile_exhibitor',
    sponsor: 'profile_sponsor',
    speaker: 'profile_speaker'
  },
  bookmark: 'bookmarks',
  news: 'news',
  message: 'message',
  attendee: 'attendee',
  community: 'community',
  social: 'social',
  gamification: 'gamification',
  gallery: 'gallery',
  survey: 'survey',
  agenda: 'agenda',
  notes: 'notes',
  webview: 'webview',
  maps: 'maps',
  eventguide: 'about',
  tickets: 'tickets',
  notifications: 'notifications',
  globalsearch: 'globalsearch',
  scans: 'scan', // 'myscans
  users: 'users',
  polls: 'polls',
  meetings: 'meetings',
  itinerary: 'itinerary',
  analytics: 'analytics',
  activity: 'activity'
};

export const ALL_APPTAB_KEYS = {
  overview: 'overview',
  schedule: 'schedule',
  exhibitor: 'exhibitor',
  sponsor: 'sponsor',
  speaker: 'speaker',
  profile: {
    personal: 'profile_personal',
    exhibitor: 'profile_exhibitor',
    sponsor: 'profile_sponsor',
    speaker: 'profile_speaker'
  },
  bookmark: 'bookmark',
  news: 'news',
  message: 'message',
  attendee: 'attendee',
  community: 'community',
  social: 'social',
  gamification: 'gamification',
  gallery: 'gallery',
  survey: 'survey',
  agenda: 'agenda',
  notes: 'notes',
  webview: 'webview',
  maps: 'maps',
  eventguide: 'about',
  itinerary: 'itinerary',
  tickets: 'tickets',
  notifications: 'notifications',
  globalsearch: 'globalsearch',
  scans: 'scan', // 'myscans
  users: 'users',
  polls: 'polls',
  outreach: 'outreach',
  analytics: 'analytics',
  proposal: 'proposal',
  support: 'support',
  btm: {
    home: 'btm-home',
    exhibitor: 'btm-exhibitor',
    social: 'btm-social',
    schedule: 'btm-schedule',
    community: 'btm-community'
  }
};

export const SHIMMER_ITEMS = {
  agenda: 'agenda',
  eventguide: 'eventGuide',
  eventguideDetails: 'eventGuideDetails',
  maps: 'maps',
  mapDetails: 'mapDetails',
  notes: 'notes',
  noteDetails: 'noteDetails',
  scans: 'scans',
  news: 'news',
  newsDetails: 'newsDetails',
  webView: 'webView',
  userChat: 'userchat',
  gallery: 'gallery',
  notifications: 'notifications',
  socialPosts: 'socialPosts',
  sessiondates: 'sessionDates',
  sessionlist: 'sessionLists',
  sessionCalendar: 'sessionCalendar',
  surveyList: 'surveyLists',
  speakerlist: 'speakerLists',
  socialPoll: 'socialPoll',
  attendeelists: 'attendeeLists',
  attendeeDetails: 'attendeeDetails',
  exhibitorlist: 'exhibitorList',
  sponsorlist: 'sponsorList',
  exhibitorDetails: 'exhibitorDetails',
  liveQaPosts: 'liveQaPosts',
  sessionpolls: 'sessionPolls',
  comments: 'comments',
  chats: 'chats',
  calendar: 'calendar',
  speakerDetails: 'speakerDetails',
  gamificationChallenges: 'gamificationChallenges',
  gamificationLeaderboard: 'gamificationLeaderboard',
  sponsorDetails: 'sponsorDetails',
  communitylists: 'communityLists',
  communitypostDetails: 'communityPostDetails',
  sideBar: 'sidebar'
};

export const OVERVIEW_FEATURE_ITEMS = [
  ALLOWED_FEATURE_KEYS.schedule,
  ALLOWED_FEATURE_KEYS.exhibitor,
  ALLOWED_FEATURE_KEYS.speaker,
  ALLOWED_FEATURE_KEYS.sponsor,
  ALLOWED_FEATURE_KEYS.maps,
  ALLOWED_FEATURE_KEYS.message,
  ALLOWED_FEATURE_KEYS.news,
  ALLOWED_FEATURE_KEYS.attendee,
  ALLOWED_FEATURE_KEYS.social,
  ALLOWED_FEATURE_KEYS.meetings,
  ALLOWED_FEATURE_KEYS.gamification,
  ALLOWED_FEATURE_KEYS.webview
];

export const OVERVIEW_FEATURE_FETCH_LIMITS = {
  exhibitor: 100,
  speaker: 100,
  sponsor: 100,
  schedule: 30
};

export const ALLOWED_NOTE_DETAILS_OPEN_TYPES = {
  add: 'add',
  update: 'update'
};

export const MULTI_TAB_FEATURES = [
  ALLOWED_FEATURE_KEYS.schedule,
  ALLOWED_FEATURE_KEYS.gallery,
  ALLOWED_FEATURE_KEYS.news,
  ALLOWED_FEATURE_KEYS.webview
];

export const FEATURED_LIMIT = 100000;
export const POST_PIN_DEFAULT_VALUE = 100000;

export const TRIVIA_FORM_INIT_STATE = {
  state: false,
  for: null, // trivia id
  form: null, // trivia form data
  checkoutForm: null // trivia checkout form
};

export const ALLOWED_COOKIE_CONSENT_OPTIONS = [
  {
    text: LocalStrings.dynamic.kCookieOptionFunctionality,
    checked: true
  },
  {
    text: LocalStrings.dynamic.kCookieOptionAnalyticsStorage,
    checked: true
  },
  { text: LocalStrings.dynamic.kCookieOptionAdStorage, checked: true },
  { text: LocalStrings.dynamic.kCookieOptionAdUserData, checked: true },
  {
    text: LocalStrings.dynamic.kCookieOptionAdPersonalisation,
    checked: true
  },
  {
    text: LocalStrings.dynamic.kCookieOptionPersonalizationStorage,
    checked: true
  },
  {
    text: LocalStrings.dynamic.kCookieOptionSecurityStorage,
    checked: true
  }
];

export const LOGIN_ERROR_EMAIL_NOT_REGISTERED = [
  'Requester email is not registerd with this event!',
  'Requester user is not registerd with this event!'
];
export const LOGIN_RESULT_MAGIC_LINK_SENT = 'Magic Link sent succesfully!';
